import React, { useState, useEffect } from "react";
import { getApplicationComment } from "../../services/Application";
import "./CaseMessages.css";
import CardHeader from "./CardHeader";
import LoadingSpinner from "./LoadingSpinner";
import CommunicationPanel from "./CommunicationPanel";
import { useAuth } from "../../context/AuthContext";


import logger from "../../utils/logger";
const CaseMessages = ({
  caseData,
  scrollIntoViewOnLoad = false,
  pendingMessageSenderRef = null,
}) => {
  const { accessToken } = useAuth();
  const sectionRef = React.useRef(null);
  const hasScrolledIntoViewRef = React.useRef(false);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await getApplicationComment(
        caseData.id,
        5,
        "CaseCommunication",
        null,
        accessToken
      );

      if (response) {
        setMessages(response);
      } else {
        setMessages({
          id: "CaseCommunication",
          status: "none",
          Conversation: [],
        });
      }
    } catch (error) {
      logger.error("Failed to fetch application comments:", error);
      setError(error.message || "Błąd podczas ładowania wiadomości");
      setMessages({
        id: "CaseCommunication",
        status: "none",
        Conversation: [],
      });
    } finally {
      setLoading(false);
    }
  };

  const handleMessageSent = async () => {
    await fetchData();
  };

  const communicationCallbacks = {};

  useEffect(() => {
    if (caseData?.id && accessToken) {
      fetchData();
    }
  }, [caseData?.id, accessToken]);

  useEffect(() => {
    hasScrolledIntoViewRef.current = false;
  }, [caseData?.id, scrollIntoViewOnLoad]);

  useEffect(() => {
    if (
      !scrollIntoViewOnLoad ||
      loading ||
      hasScrolledIntoViewRef.current
    ) {
      return;
    }

    sectionRef.current?.scrollIntoView?.({
      behavior: "smooth",
      block: "start",
    });
    hasScrolledIntoViewRef.current = true;
  }, [loading, scrollIntoViewOnLoad]);

  if (loading) {
    return (
      <div id="case-messages" ref={sectionRef}>
        <CardHeader text="Wiadomości do operatora" onlyText="true" />
        <div className="card container-fluid shadow ms-4 px-4 py-3 w55">
          <div className="d-flex flex-column w47">
            <LoadingSpinner />
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div id="case-messages" ref={sectionRef}>
        <CardHeader text="Wiadomości do operatora" onlyText="true" />
        <div className="card container-fluid shadow ms-4 px-4 py-3 w55">
          <div className="d-flex flex-column w47">
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
            <button className="btn btn-primary mt-2" onClick={fetchData}>
              Spróbuj ponownie
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id="case-messages" ref={sectionRef}>
      <CardHeader text="Wiadomości do operatora" onlyText="true" />
      <div className="card container-fluid shadow ms-4 px-4 py-3 w55">
        <div className="d-flex flex-column w47">
          <CommunicationPanel
            data={messages}
            isVisible={true}
            embedded={true}
            communicationCallbacks={communicationCallbacks}
            onMessageSend={handleMessageSent}
            caseId={caseData.id}
            step={5}
            persistent={true}
            allowMarkAsRead={true}
            pendingMessageSenderRef={pendingMessageSenderRef}
          />
        </div>
      </div>
    </div>
  );
};

export default CaseMessages;


